// localStorage 키
const STORAGE_KEY = 'dashboard-layout';

/**
 * 레이아웃 정규화 - 모든 그룹이 항상 존재하도록 보장
 */
export const normalizeLayout = (layout, cardGroups) => {
  const normalized = { ...layout };
  
  // 모든 그룹을 항상 초기화 (없으면 빈 배열)
  Object.values(cardGroups).forEach((group) => {
    if (!normalized[group]) {
      normalized[group] = [];
    }
  });
  
  return normalized;
};

/**
 * 대시보드 레이아웃을 localStorage에 저장
 */
export const saveDashboardLayout = (layout) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(layout));
  } catch (error) {
    console.warn('대시보드 레이아웃 저장 실패:', error);
  }
};

/**
 * localStorage에서 대시보드 레이아웃 불러오기
 */
export const loadDashboardLayout = (cardGroups) => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const layout = JSON.parse(saved);
      // 로드된 레이아웃도 정규화하여 모든 그룹이 존재하도록 보장
      return normalizeLayout(layout, cardGroups);
    }
  } catch (error) {
    console.warn('대시보드 레이아웃 불러오기 실패:', error);
  }
  return null;
};

/**
 * 기본 레이아웃 생성
 */
export const createDefaultLayout = (cardDefaults, cardGroups) => {
  const layout = {};
  
  // 모든 그룹을 먼저 초기화
  Object.values(cardGroups).forEach((group) => {
    layout[group] = [];
  });
  
  // 그룹별로 카드 배열 생성
  Object.values(cardDefaults).forEach((card) => {
    if (!layout[card.group]) {
      layout[card.group] = [];
    }
    layout[card.group].push({ ...card });
  });
  
  // 각 그룹별로 y, x 기준 정렬 (Y 좌표 우선, 그 다음 X 좌표)
  Object.keys(layout).forEach((group) => {
    if (layout[group].length > 0) {
      layout[group].sort((a, b) => {
        if (a.y !== b.y) return (a.y || 0) - (b.y || 0);
        return (a.x || 0) - (b.x || 0);
      });
    }
  });
  
  return layout;
};

